import 'angular';

// We depend on corejs for polyfilling standard library support for older browsers (I'm looking at you IE). It should be
// included as an external. Sadly Webpack doesn't allow for externals that don't insert variables into the scope (corejs
// just polyfills), so this comment is left here for reference for the future generations to show that we actually do
// have a dependency on corejs.
// import 'core-js';

import ngAria from 'angular-aria';
import ngAnimate from 'angular-animate';
import ngCookies from 'angular-cookies';
import ngStorage from '../common/wrappers/ngstorage';
import ngTouch from 'angular-touch';
import angularSpinner from '../common/wrappers/angular-spinner';
import gettext from 'angular-gettext';
import raven from '../common/wrappers/raven';

import djangoCsrfIntercept from '../common/django-csrf-intercept/django_csrf_intercept.module';

// Import styles that are common for every bundle
import '../scss/commons.scss';
import '../scss/spinner.scss';
import '../scss/animations.scss';
import '../scss/modals.scss';

/**
 * Imports that are shared for every bundle.
 *
 * Try to keep this list as minimal as possible, as it will raise the common bundle size.
 *
 * Bundle should use this list as follows:
 *
 *   angular.module('foo', _.union(COMMON_IMPORTS, [...]));
 *
 * @type {Array.<string>}
 */
const COMMON_IMPORTS = [
  /**
   * Core Angular components
   */

  'ng',                     // angular and compiled HTML templates
  ngAria,                   // angular-aria
  ngAnimate,                // angular-animate
  ngCookies,                // angular-cookies

  /**
   * Custom Angular components
   */

  ngStorage,                // ngStorage, provides $localStorage and $sessionStorage
  ngTouch,                  // angular-touch
  angularSpinner,
  gettext,

  /**
   * Project / build specific Angular components
   */

  djangoCsrfIntercept,

  /**
   * Custom application components
   */
  raven,
];

export default COMMON_IMPORTS;



// WEBPACK FOOTER //
// ./src/app/common.imports.js